export const categoryLabel = (cat) => {
  const labels = {
    // emisiones GEI
    'generacion electrica': 'Generación Eléctrica',
    'industria y mineria': 'Industria y Minería',
    publico: 'Público',
    'otras industrias energia': 'Otras Industrias Energía',
    'otros sectores': 'Otros Sectores',
    'emisiones fugitivas': 'Emisiones Fugitivas',
    'procesos industriales': 'Procesos Industriales',
    forestal: 'Forestal',

    // demanda energia
    azucar: 'Azúcar',
    industrias_varias: 'Industrias varias',
    minas_varias: 'Minas varias',
    petroquimica: 'Petroquímica',
    siderurgia: 'Siderúrgica',
    transporte_aereo: 'Transporte aéreo',
    transporte_caminero_carga: 'Trans. caminero \ncarga',
    transporte_caminero_pasajeros: 'Trans. caminero \npasajeros',
    transporte_ferroviario_carga: 'Trans. ferroviario \ncarga',
    transporte_ferroviario_pasajeros: 'Trans. ferroviario \npasajeros',
    transporte_maritimo: 'Transporte marítimo',

    // generacion
    carbon: 'Carbón',
    eolica: 'Eólica',
    'hidraulica embalse': 'Hidráulica embalse',
    'hidraulica pasada': 'Hidráulica pasada',
    'hidraulica serie': 'Hidráulica serie',
  };

  return labels[cat]
    ? labels[cat] : cat.charAt(0).toUpperCase() + cat.slice(1);; 
};

export const parseValue = value => ( value ? parseFloat(value.replace(/,/g, '')) : null);

export const truncOneDecimal = (value) => {
  const parts = String(value).split(',');
  if (parts.length > 1) {
    return parts[0] + ',' + parts[1][0];
  }
  return value;
}
export const truncTwoDecimals = (value) => {
  const parts = String(value).split(',');
  if (parts.length > 1) {
    return parts[0] + ',' + parts[1][0-1];
  }
  return value;
}
export const numberToTwoDecimals = (value) => {
  return Number(value).toFixed(2)
}
export const toOneDecimal = (dic) => {
  const new_dict = {};
  for(var x in dic){
      new_dict[x] = Number(dic[x]).toFixed(1)
  }
  return new_dict
}
export const toTwoDecimals = (dic) => {
  const new_dict = {};
  for(var x in dic){
      new_dict[x] = Number(dic[x]).toFixed(2)
  }
  return new_dict
}